var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-swipe',{attrs:{"autoplay":3000,"indicator-color":"white"}},_vm._l((_vm.list),function(item){return _c('van-swipe-item',{key:item.id},[_c('img',{attrs:{"src":item.url,"alt":""}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }